module.exports = __webpack_public_path__ + "static/media/vg.4236b359.svg";